// extracted by css-extract-rspack-plugin
export default {"MultiSelectInput":"D88EN"};